import axios from 'axios';

export const api = (auth_data) => {
    return axios.create({
        baseURL: 'https://webapi.fastn.co.kr/api',
        headers: {
            Authorization: `${auth_data}`,
        },
    })
};